/**
 * `AssetPort`（索引 Issue #498 の段階 4）— **素材の URL をどう引くか**。
 *
 * | メソッド | 中身 |
 * |---|---|
 * | `url(name)` | 名前 → URL（無ければ null） |
 * | `list(prefix)` | 名前の一覧 |
 * | `preload(names)` | 先に取ってくる（Promise を返してよい） |
 * | `subscribe(fn)` | 一覧が増えたら呼ぶ |
 *
 * 実装は共通編集素材（S3 の `editAssets/`）。**署名付き URL は期限が来る**ので、描くたびに引き直せるよう
 * 値ではなく関数で渡す（演出プレビューで灰色のカードになった原因。Issue #362 / #380）。
 */
import { definePort } from './define';

export const AssetPort = definePort('AssetPort', {
  url: () => null,
  list: () => [],
  preload: () => undefined,
  subscribe: () => () => {},
});
